import { w as o } from "./index760.mjs";
import { i as a } from "./index872.mjs";
var t = o, e = a, n = t("iterator"), y = Array.prototype, m = function(r) {
  return r !== void 0 && (e.Array === r || y[n] === r);
};
export {
  m as i
};
